<template>
    <div>
        <input type="hidden" name="voucherArray" :value="JSON.stringify(vouchersUsed)" />
        <label class="ckp-label" for="voucher_code">Numéro du bon cadeau</label>
        <div class="ckp-code-row">
            <input
                type="text"
                name="voucher_code"
                id="voucher_code"
                ref="voucherCode"
                class="ckp-input"
                placeholder="0000000000"
                autocomplete="off"
                @keydown.enter.prevent="handleVoucherCodeSearch()"
            />
            <button type="button" class="ck-button" @click="handleVoucherCodeSearch()">Appliquer</button>
        </div>
        <p v-if="invalidVoucher" class="ckp-note is-error">{{ error || "Ce bon cadeau n'existe pas ou a déjà été utilisé en totalité." }}</p>
        <p v-if="voucherBlocked" class="ckp-note is-error">Ce bon cadeau est bloqué.</p>
        <p v-if="voucherAmountNull" class="ckp-note is-error">Ce bon cadeau a déjà été utilisé en totalité.</p>

        <section v-if="vouchersUsed.length" class="ckp-group ckp-applied">
            <div class="ckp-section-head">
                <h3 class="ckp-title">Bons cadeau appliqués</h3>
                <span class="ckp-hint">{{ vouchersUsed.length }} bon{{ vouchersUsed.length > 1 ? 's' : '' }} · {{ euro(voucherTotal) }} disponible{{ vouchersUsed.length > 1 ? 's' : '' }}</span>
            </div>
            <div v-for="(item, i) in vouchersUsed" :key="item.id || i" class="ckp-card ckp-applied-card">
                <div class="ckp-applied-main">
                    <strong>{{ item.code }}</strong>
                    <small>
                        {{ euro(item.available_amount) }} disponible<template v-if="toAmount(item.reserved_amount) > 0"> ({{ euro(item.reserved_amount) }} réservé)</template>
                        <template v-if="item.date_end"> · valable jusqu'au {{ parseDate(item.date_end) }}</template>
                    </small>
                </div>
                <label class="ckp-impute">
                    <span>À imputer</span>
                    <span class="ckp-money">
                        <i>€</i>
                        <input
                            type="number"
                            min="0"
                            step="0.01"
                            placeholder="0"
                            :max="voucherMaxAmount(item)"
                            v-model="item.amount"
                            @input="clampVoucherAmount(item)"
                            @blur="clampVoucherAmount(item)"
                            :aria-label="'Montant à imputer sur le bon ' + item.code"
                        />
                    </span>
                </label>
                <button type="button" class="ckp-icon" title="Retirer ce bon" aria-label="Retirer ce bon" @click="deleteBC(item)"><i class="bi bi-x-lg"></i></button>
            </div>
            <p v-for="discount in voucherPriceAlignmentDiscounts" :key="discount.voucherId + '-' + discount.cartKey" class="ckp-note">
                Remise liée au bon cadeau · {{ discount.prestationName }} : −{{ euro(discount.amount) }}
            </p>
        </section>
    </div>
</template>

<script>
import ApiManager from '../../Calendar/_core/ApiManager'
import { get, sync } from 'vuex-pathify'

export default {
    data: () => ({
        // voucher
        voucher: null,
        voucherArray: [],
        // voucherTotal: 0,
        voucherEntered: false,
        voucherApplied: false,
        voucherBlocked: false,
        invalidVoucher: false,
        voucherAmountNull: false,
        error: null,
        vouchersUsed: [],
    }),
    mounted() {
        this.getselectedVoucherItems()
    },
    computed: {
        ...sync('overlay@data', {
            c_payments: 'payments',
            c_voucherUsed: 'voucherUsed',
            c_cartItems: 'cartItems',
        }),
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
        }),
        voucherTotal() {
            return this.vouchersUsed.reduce((total, voucher) => {
                return total + parseFloat(voucher.available_amount || 0)
            }, 0)
        },
        voucherPriceAlignmentDiscounts() {
            const usedCartItems = new Set()

            return this.vouchersUsed.flatMap(voucher => {
                const linkedItems = (voucher.items || []).filter(item =>
                    item.item_type === 'App\\Models\\Prestation\\Prestation' && this.toAmount(item.amount) > 0
                )
                const purchasedTotal = linkedItems.reduce((total, item) => total + this.toAmount(item.amount), 0)

                if (!linkedItems.length || this.toAmount(voucher.amount) + 0.009 < purchasedTotal) {
                    return []
                }

                const remainingCartItems = Object.entries(this.c_cartItems || {})
                    .filter(([cartKey, item]) => !usedCartItems.has(cartKey) && !item.pendingRemoval)
                const discounts = []
                const voucherCartKeys = []

                for (const linkedItem of linkedItems) {
                    const cartIndex = remainingCartItems.findIndex(([, item]) =>
                        item.options &&
                        item.options.type === linkedItem.item_type &&
                        Number(item.options.item_id) === Number(linkedItem.item_id)
                    )

                    if (cartIndex < 0) {
                        return []
                    }

                    const [cartKey, cartItem] = remainingCartItems.splice(cartIndex, 1)[0]
                    voucherCartKeys.push(cartKey)
                    const currentAmount = this.toAmount(cartItem.price) * this.toAmount(cartItem.qty || 1)
                    const discount = Math.max(0, Math.round((currentAmount - this.toAmount(linkedItem.amount)) * 100) / 100)

                    if (discount > 0) {
                        discounts.push({
                            voucherId: voucher.id,
                            cartKey,
                            prestationName: cartItem.name,
                            amount: discount,
                        })
                    }
                }

                voucherCartKeys.forEach(cartKey => usedCartItems.add(cartKey))

                return discounts
            })
        },
    },
    watch: {
        // voucherArray(newVal) {
        //     newVal.forEach(el => {
        //         if (!this.vouchersUsed.find(v => v.code == el.code)) {
        //             this.vouchersUsed.push({ id: el.id, code: el.code, amount: Math.min(this.c_remainPrice, el.available_amount), available_amount: el.available_amount, date_end:el.date_end })
        //         }
        //     })
        // },
        voucherArray(newVal) {
            newVal.forEach(el => {

                const realAvailableAmount =
                    Math.max(
                        0,
                        this.toAmount(el.available_amount) -
                        this.toAmount(el.reserved_amount)
                    )

                if (!this.vouchersUsed.find(v => v.code == el.code)) {

                    this.vouchersUsed.push({
                        id: el.id,
                        code: el.code,

                        amount: this.clampAmount(
                            Math.min(this.toAmount(this.c_remainPrice), realAvailableAmount),
                            realAvailableAmount
                        ),

                        available_amount: realAvailableAmount,

                        reserved_amount: el.reserved_amount,

                        date_end: el.date_end,

                        items: el.items || []
                    })
                }
            })
        },
        vouchersUsed: {
            handler(newVal) {
                newVal.forEach(item => this.clampVoucherAmount(item))
                this.c_voucherUsed = this.vouchersUsed;
                this.emitVoucherSummary()
            },
            deep: true,
        },
        c_cartItems: {
            handler() {
                this.emitVoucherSummary()
            },
            deep: true,
        },
    },
    methods: {
        toAmount(value) {
            const amount = parseFloat(String(value ?? 0).replace(',', '.'))

            return Number.isFinite(amount) ? amount : 0
        },
        formatAmount(value) {
            return this.toAmount(value).toFixed(2)
        },
        voucherDiscountsFor(voucher) {
            return this.voucherPriceAlignmentDiscounts.filter(discount => discount.voucherId === voucher.id)
        },
        emitVoucherSummary() {
            this.$emit('vouchers-update', {
                amount: this.vouchersUsed.reduce((total, voucher) => total + this.toAmount(voucher.amount), 0),
                alignmentDiscount: this.voucherPriceAlignmentDiscounts
                    .reduce((total, discount) => total + discount.amount, 0),
            })
        },
        voucherMaxAmount(item) {
            const currentVoucherCapacity = Math.max(
                0,
                this.toAmount(this.c_remainPrice) + this.toAmount(item.amount)
            )
            const capacityAfterOtherPayments = Math.max(
                0,
                this.toAmount(this.c_remainAfterGlobalPromoCode)
                    - this.nonVoucherPaymentsAmount()
                    - this.otherVouchersAmount(item)
            )
            const paymentCapacity = Math.min(
                currentVoucherCapacity || capacityAfterOtherPayments,
                capacityAfterOtherPayments
            )

            return Math.max(
                0,
                Math.min(
                    paymentCapacity,
                    this.toAmount(item.available_amount)
                )
            )
        },
        nonVoucherPaymentsAmount() {
            if (!this.c_payments) {
                return 0
            }

            return this.c_payments
                .filter(payment => payment.name !== 'Bon cadeau')
                .reduce((total, payment) => total + this.toAmount(payment.value), 0)
        },
        otherVouchersAmount(currentItem) {
            return this.vouchersUsed
                .filter(item => item.id !== currentItem.id)
                .reduce((total, item) => total + this.toAmount(item.amount), 0)
        },
        clampAmount(value, max) {
            const amount = this.toAmount(value)
            const capped = Math.min(Math.max(amount, 0), Math.max(0, this.toAmount(max)))

            return Math.round(capped * 100) / 100
        },
        clampVoucherAmount(item) {
            if (item.amount === '' || item.amount === null || item.amount === undefined) {
                return
            }

            const capped = this.clampAmount(item.amount, this.voucherMaxAmount(item))

            if (this.toAmount(item.amount) !== capped) {
                item.amount = capped
            }
        },
        async getselectedVoucherItems() {
            await ApiManager.getselectedVoucherItems(0).then(res => {
                if (res.data != 0) {
                    res.data.forEach(element => {
                        this.handleVoucherCodeSearch()
                    })
                }
            })
        },
        handleVoucherCodeSearch() {
            // this.$refs.voucherCode.value = 7755872296
            //console.log('rzea')

            if (this.$refs.voucherCode.value !== '') {

                axios
                    .get(`/back-office/voucher/check-code`, {
                        params: { code: this.$refs.voucherCode.value },
                    })
                    .then(res => {
                        // Si le code est invalide
                        console.log(res.data)
                        if (!res.data || Object.keys(res.data).length === 0) {
                            this.error = null
                            this.voucherApplied = false
                            this.voucher = null
                            this.voucherAmountNull = false
                            this.invalidVoucher = true
                        } else {
                            if (typeof res.data === 'string') {
                                this.invalidVoucher = true
                                this.voucherApplied = false
                                this.voucher = null
                                this.voucherAmountNull = false
                                this.error = res.data
                            } else {
                                if (
                                    !this.voucherArray
                                        .map(e => {
                                            if (e.id == res.data.id) return false
                                        })
                                        .includes(false)
                                ) {
                                    this.voucherArray.push(res.data)
                                    // this.voucherTotal += res.data.available_amount
                                    // this.voucherTotal +=
                                    //     parseFloat(res.data.available_amount || 0) -
                                    //     parseFloat(res.data.reserved_amount || 0)
                                    document.getElementById('voucher_code').value = ''
                                }
                                this.voucher = res.data
                                if (this.voucher.is_blocked) {
                                    this.voucherBlocked = true
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = false
                                } else if (this.voucher.available_amount == 0) {
                                    this.voucherBlocked = false
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = true
                                } else {
                                    this.invalidVoucher = false
                                    this.voucherApplied = true
                                    this.voucherAmountNull = false
                                    this.voucherBlocked = false
                                }
                            }
                        }
                    })
                    .catch(err => {
                        this.invalidVoucher = true
                        this.voucherApplied = false
                        this.voucher = null
                        this.voucherAmountNull = false
                        this.error = err.response.data['message']
                    })
            } else {
                this.currentVoucher = null
            }
        },
        euro(value) {
            return this.toAmount(value).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
        },
        parseDate(date) {
            moment.locale('fr')
            return moment(date).format('DD/MM/YYYY')
        },

        deleteBC(e) {
            const isLargeNumber = element => element.id == e.id
            const voucherToDelete = this.voucherArray.find(isLargeNumber)
            const index = this.voucherArray.findIndex(isLargeNumber)
            if (index > -1) {
                this.voucherArray.splice(index, 1)
                // this.voucherTotal -= e.available_amount
                this.vouchersUsed.splice(
                    this.vouchersUsed.findIndex(v => v.code == voucherToDelete.code),
                    1
                )
            }
        },
    },
}
</script>

<style></style>
